/*
 * @Author: Tina Huang
 * @Date: 2024-02-18 15:42:59
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-08 15:33:44
 * @Description:
 */

import { Button } from 'antd'
import { useNavigate } from 'react-router-dom'

export default function ToUseButton(props: { home?: boolean; hide?: boolean } = { home: false, hide: false }) {
  const { home, hide } = props

  const names = `${home ? 'w-48' : ''} ${hide ? 'hidden' : ''}`
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('/libs')
  }

  return (
    <Button className={names} type="primary" size="large" shape="round" onClick={handleClick}>
      立即使用
    </Button>
  )
}
